import ArrowIcon from "@/components/ui/icons/ArrowIcon";
import McpBadgeConnector from "./icons/McpBadgeConnector";
import Container from "@/components/ui/Container";
import laptop from "@/assets/mcp/laptop.webp";

const features = [
  "Выявляет причины инцидентов за минуты",
  "Прогнозирует риски и деградации",
  "Даёт рекомендации для принятия решения",
];

export default function HeroSection() {
  return (
    <section className="relative flex min-h-[calc(100vh-55px)] flex-col justify-center overflow-hidden rounded-b-[25px] bg-navy-900 min-[478px]:rounded-b-[35px] xl:min-h-[calc(100vh-88px)]">
      <Container>
        <div className="xl:pt-[74px] xl:pb-[120px] min-[478px]:pt-[60px] min-[478px]:pb-[100px] pt-10 pb-[60px]">
          <div className="relative md:min-h-[560px] xl:min-h-[420px]">
            <McpBadgeConnector
              label="Model Context Protocol"
              description="Способ подключить систему мониторинга Ключ-АСТРОМ к ИИ-ассистенту и вывести информацию пользователю"
            />

            {/* TODO: Уточнить по размеру h1 для 478 и 768 - текст переносится не, как в макете*/}
            <h1 className="mt-10 min-[478px]:mt-[60px] md:mt-[76px] xl:mt-[106px] font-bold leading-none text-white text-[38px] tracking-[-0.38px] min-[478px]:text-[46px] min-[478px]:tracking-[-0.46px] xl:text-[70px] xl:tracking-[-1.4px]">
              <span className="whitespace-nowrap">Модуль MCP</span>{" "}
              <span className="whitespace-nowrap">Ключ-АСТРОМ</span>
            </h1>

            <p className="mt-5 min-[478px]:mt-[25px] md:mt-[30px] xl:mt-5 font-normal text-white text-[16px] leading-[1.4] md:text-[18px] xl:leading-[1.35] md:max-w-[340px] xl:max-w-[660px]">
              MCP анализирует всю цифровую систему и превращает данные
              наблюдаемости в выводы, прогнозы и рекомендации для ИТ и бизнеса
            </p>

            <img
              src={laptop}
              alt=""
              aria-hidden="true"
              className="pointer-events-none mt-10 w-full select-none mix-blend-plus-lighter md:absolute md:right-0 md:top-[190px] md:mt-0 md:w-[67%] xl:top-[38px] xl:w-[43%]"
            />
          </div>

          <div className="relative z-10 -mt-24 min-[478px]:-mt-28 md:mt-0 flex flex-col gap-[10px] min-[478px]:gap-5 md:flex-row md:flex-wrap">
            {features.map((text) => (
              <div
                key={text}
                className="flex min-h-[80px] flex-row items-center gap-5 rounded-[25px] bg-white px-[25px] py-3 md:min-h-[130px] md:flex-1 md:flex-col md:items-start md:gap-4 md:p-[25px] xl:min-h-[132px] xl:flex-none xl:w-[320px]"
              >
                <ArrowIcon />
                <span className="font-medium leading-[1.3] text-[#202020] text-[14px] xl:text-[16px]">
                  {text}
                </span>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}
